import b from 'b_';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../Button';
import './ConsoleListAction.css';

const block = b.lock('ConsoleListAction');
export default function ConsoleListAction({ className, global = false, ...props }) {
    return <Button
        className={cn(block({ global }), className)}
        {...props}
    />;
}

ConsoleListAction.propTypes = {
    global: PropTypes.bool,
};
